import { Component } from '@theme/component';
import { Scroller } from '@theme/scrolling';

/**
 * Why Pyjama Pack section — mobile horizontal scroll with navigation arrows.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} scroller
 * @property {HTMLButtonElement} [previous]
 * @property {HTMLButtonElement} [next]
 *
 * @extends {Component<Refs>}
 */
class WhyPyjamaPack extends Component {
  requiredRefs = ['scroller'];

  /** @type {Scroller | null} */
  #scroller = null;

  connectedCallback() {
    super.connectedCallback();

    if (this.dataset.mobileLayout !== 'scroll') return;

    this.#scroller = new Scroller(this.refs.scroller, {
      onScroll: this.#updateNavigation,
    });

    this.refs.previous?.addEventListener('click', () => this.#scrollBy('previous'));
    this.refs.next?.addEventListener('click', () => this.#scrollBy('next'));

    this.#updateNavigation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#scroller?.destroy();
    this.#scroller = null;
  }

  /**
   * @param {'previous' | 'next'} direction
   */
  #scrollBy(direction) {
    const scroller = this.refs.scroller;
    const card = scroller.querySelector('.why-pyjama-pack__card');

    if (!card) return;

    const styles = getComputedStyle(scroller);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    const amount = card.getBoundingClientRect().width + gap;

    scroller.scrollBy({
      left: direction === 'next' ? amount : -amount,
      behavior: 'smooth',
    });
  }

  #updateNavigation = () => {
    const scroller = this.refs.scroller;
    const { previous, next } = this.refs;
    const tolerance = 2;
    const maxScroll = scroller.scrollWidth - scroller.clientWidth;

    if (previous) {
      previous.disabled = scroller.scrollLeft <= tolerance;
    }

    if (next) {
      next.disabled = scroller.scrollLeft >= maxScroll - tolerance;
    }
  };
}

if (!customElements.get('why-pyjama-pack-component')) {
  customElements.define('why-pyjama-pack-component', WhyPyjamaPack);
}
